var _style, _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPathHiking(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 44 44",
    style: {
      enableBackground: "new 0 0 44 44"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EB6608;}\n\t.st1{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    className: "st0",
    d: "M22,0c12.2,0,22,9.9,22,22s-9.8,22-22,22S0,34.1,0,22l0,0C0,9.9,9.9,0,22,0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_95-2",
    transform: "translate(161.406 378.799)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    className: "st1",
    d: "M-138.7-365.3l0.4,0.3l-0.5,3.8c0.6-0.3,1.1-0.6,1.7-0.9l0.6-3.6l-1.7-1.6L-138.7-365.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    className: "st1",
    d: "M-140.3-361.2l1.9-8.1l0.8,0.4l2.5-0.8l0.2-1l-2.4,0.3l-2.2-1.6l-0.8,0.4l-0.7,0.3l-0.6,3.5 l0.5,0.8l-0.8,4.9L-140.3-361.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    className: "st1",
    d: "M-137.1-374c0.1,0.8-0.5,1.5-1.3,1.6c-0.8,0.1-1.5-0.5-1.6-1.3c-0.1-0.8,0.5-1.5,1.3-1.6 C-137.9-375.3-137.2-374.8-137.1-374"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_154",
    x: -144.8,
    y: -371.5,
    transform: "matrix(0.1995 -0.9799 0.9799 0.1995 249.1414 -436.4366)",
    className: "st1",
    width: 4.5,
    height: 1.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPathHiking);
export default __webpack_public_path__ + "static/media/path-hiking.2f49c707.svg";
export { ForwardRef as ReactComponent };